export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Light.862613d9.woff2";